import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';

import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';

// Services
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly authService: AuthService, private readonly router: Router, private readonly dialog: MatDialog) { }

  private readonly urlsWithoutAuth: string[] = [
    environment.apiUrl + '/auth',
    environment.apiUrl + '/auth/azureAD',
    environment.apiUrl + '/auth/basic',
    environment.apiUrl + '/auth/saml'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = this.authService.getAuthorizationToken();
    let request: HttpRequest<any> = req;
    
    // Verifica se a URL começa com alguma das URLs sem autenticação
    const isUrlWithoutAuth = this.urlsWithoutAuth.some(url => request.url.startsWith(url));
    
    if (!isUrlWithoutAuth && request.url.split('/')[2] !== 's3.amazonaws.com') {
      request = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
      return next.handle(request).pipe(catchError(err => this.handleAuthError(err)));
    } else {
      return next.handle(request);
    }
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401 || err.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      this.dialog.closeAll();
      this.router.navigate(['/autenticacao/login']);
      return of(err.message);
    }
    return throwError(() => err);
  }

}
